export const API_ENDPOINTS = {
    GET_CUSTOMER_OFFER_LIST: '/getCustomerOffers',
    GET_USER_DETAILS: '/Offers',
    GENERATE_OFFER: '/Save',
    LOGIN: '/login',
};